// use below baseURL
export const BaseURL1 = process.env.REACT_APP_API_BASEURL;
